module.exports = __webpack_public_path__ + "img/voice-icon7.59bfe05.png";